module.exports = __webpack_public_path__ + "admin/img/module_icon_worshipset.baf3a2cc.svg";